export enum RemoveDeviceFromGatewayStatus {
	InProgress = 'IN_PROGRESS',
	Success = 'SUCCESS',
	GenericFailure = 'GENERIC_FAILURE',
	DeviceNotFound = 'DEVICE_NOT_FOUND',
	DeviceUpdating = 'DEVICE_UPDATING',
	GatewayNotFound = 'GATEWAY_NOT_FOUND'
}

export interface RemoveDevicesFromGatewayResult {
	devices: {
		hardwareId: string;
		status: RemoveDeviceFromGatewayStatus;
	}[];
}
